import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) {
    this.accessToken = sessionStorage.getItem('accessToken');
  }

  private accessToken = '';

  get(url: string) {
    return this.http.get(url, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      },
    });
  }

  post(url: string, body: any) {
    return this.http
      .post(
        url,
        JSON.stringify(body, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: {
            Authorization: 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json; charset=utf-8',
          },
        }
      )
      .pipe(catchError((err) => this.handleError(err)));
  }

  put(url: string, body: any) {
    return this.http
      .put(
        url,
        JSON.stringify(body, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: { 'Content-Type': 'application/json' },
        }
      )
      .pipe(catchError((err) => this.handleError(err)));
  }

  delete(url: string) {
    return this.http
      .delete(url, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json; charset=utf-8',
        },
      })
      .pipe(catchError((err) => this.handleError(err)));
  }

  handleError(err: any) {
    const { status } = err;
    return throwError(() => err);
  }

  postFormData(url: string, formData: FormData) {
    return this.http
      .post(url, formData, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
        },
      })
      .pipe(catchError((err) => this.handleError(err)));
  }

  getBlob(url: string) {
    return this.http.get(url, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    });
  }
}
